// Desktop category disclosure on the auth header: flips data-state on [data-cat-toggle]
// which the CSS reveals. Closed by default in markup so no-JS users get the basic header.
(function () {
  var toggles = document.querySelectorAll('[data-cat-toggle]');
  if (!toggles.length) return;

  toggles.forEach(function (toggle) {
    var trigger = toggle.querySelector('.cat-toggle__trigger');
    if (!trigger) return;

    function setOpen(open) {
      toggle.dataset.state = open ? 'open' : 'closed';
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    trigger.addEventListener('click', function () {
      setOpen(toggle.dataset.state !== 'open');
    });

    // The toggle button lives in band 3, which slides out of view on unpin — so an
    // open dropdown must close itself, else there's no visible button to close it.
    var header = toggle.closest('header');
    if (header && typeof MutationObserver !== 'undefined') {
      new MutationObserver(function () {
        if (header.getAttribute('data-pinned') === 'false' && toggle.dataset.state === 'open') {
          setOpen(false);
        }
      }).observe(header, { attributes: true, attributeFilter: ['data-pinned'] });
    }

    // Close on a click outside the header. The drawer is part of the header subtree,
    // so header.contains() covers the trigger and the category links — only clicks
    // genuinely outside the header close the row.
    if (header) {
      document.addEventListener('click', function (event) {
        if (toggle.dataset.state === 'open' && !header.contains(event.target)) {
          setOpen(false);
        }
      });
    }
  });
})();
